<template>
  <a-modal v-model="visible" title="充值记录" width="800px">
    <a-table
        :columns="columns"
        :data-source="recordList"
        :pagination="false"
        rowKey="id"
        v-if="recordList.length > 0">
      <span slot="orderTime" slot-scope="text">{{ text ? text : '' }}</span>
      <span slot="type" slot-scope="text, record">
        <span v-if="text === 'semester'">
          <a-tag color="blue">学期卡</a-tag>
        </span>
        <span v-if="text === 'year'">
          <a-tag color="purple">年卡</a-tag>
        </span>
        <span v-if="text === 'month'">
          <a-tag color="green">月卡</a-tag>
        </span>
      </span>
      <span slot="periodCount" slot-scope="text">{{ text ? text + '期' : '' }}</span>
      <span slot="status" slot-scope="text, record">
        <span v-if="text === 'pending'">
          <a-tag color="orange">待支付</a-tag>
        </span>
        <span v-if="text === 'finished'">
          <a-tag color="green">已完成</a-tag>
        </span>
        <span v-if="text === 'cancelled'">
          <a-tag color="red">取消支付</a-tag>
        </span>
      </span>
      <span slot="totalFinalPrice" slot-scope="text">{{ text ? text : '' }}</span>
    </a-table>
    <p v-else>无记录</p>
    <template slot="footer">
      <a-button key="submit" type="primary" @click="handleOk">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import rechargeService from '@/service/recharge'

export default {
  data() {
    return {
      visible: false,
      recordList: [],
      columns: [
        {
          title: '下单时间',
          dataIndex: 'orderTime',
          scopedSlots: { customRender: 'orderTime' },
          align: 'center'
        },
        {
          title: '充值类型',
          dataIndex: 'type',
          scopedSlots: { customRender: 'type' },
          align: 'center'
        },
        {
          title: '充值期数',
          dataIndex: 'periodCount',
          scopedSlots: { customRender: 'periodCount' },
          align: 'center'
        },
        {
          title: '充值状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '金额（元）',
          dataIndex: 'totalFinalPrice',
          scopedSlots: { customRender: 'totalFinalPrice' },
          align: 'center'
        }
      ]
    };
  },
  methods: {
    showModal(userId) {
      this.visible = true;
      rechargeService.queryListByUserId({userId}).then((res) => {
        this.recordList = res.data
      })
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>
